
export const licensePlateTypes = {
    PERMANENT: 1,
    TEMPORARY: 2,
    NO_PLATE: 3,
    HANDWRITTEN: 4
}

export const licensePlateTypesList = [
    { id: licensePlateTypes.PERMANENT, name: "Permanent" },
    { id: licensePlateTypes.TEMPORARY, name: "Temporary" },
    { id: licensePlateTypes.NO_PLATE, name: "No Plate" },
    { id: licensePlateTypes.HANDWRITTEN, name: "Handwritten" }
];

export const gradeOptions = [1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0];

export const getLPTypeName = (typeId) => {
    const type = licensePlateTypesList.find(type => type.id === typeId);
    return type?.name;
};